export const SECONDS_TO_MILLISECONDS = 1000
export const HOURS_24_IN_MILLISECONDS = 24 * 60 * 60 * SECONDS_TO_MILLISECONDS
